module.exports = __webpack_public_path__ + "img/sample02-03.1503735f.png";